import { ReactNode } from 'react'
import s from './styles.module.scss'
export const TabsLayout = ({ selector, children }: { selector?: ReactNode; children?: ReactNode }) => {
  return (
    <div className={s.tabsContainer}>
      {selector}
      <div className={s.tabs}>
        <div className={s.tab}>{children}</div>
      </div>
    </div>
  )
}
